import { DragIndexState } from "./type";

export const dragActiveStyle = (dragState: DragIndexState, id: string) => {
    const { active, over, direction } = dragState;
    // drag active style
    let style: React.CSSProperties = {};
    if (active && active === id) {
        style = { backgroundColor: "gray", opacity: 0.5 };
    }
    // dragover dashed style
    else if (over && id === over.toString() && active !== over) {
        style = direction === "right" ? { borderRight: "1px dashed gray" } : { borderLeft: "1px dashed gray" };
    }
    return style;
};
